import apiClient from "./apiClient";
import {removeNullFields} from "../utils/utils";
import {InvoiceReconciliation} from "../types/invoice";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

export async function getAllInvoiceReconciliations(token: string, params: any): Promise<any> {
    try {
        params.filter = removeNullFields(params.filter);

        const response = await apiClient.post<any>(
            `${BASE_URL}/api/v1/invoice/all`,
            params,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
        )
        return response.data;
    } catch (error) {
        console.error("Error fetching directory list:", error);
        throw error;
    }
}

export async function getIsHaveSuccessActReconciliationsByDate(token: string, params: any): Promise<boolean> {
    try {
        params.filter = removeNullFields(params.filter);

        const response = await apiClient.post<any>(
            `${BASE_URL}/api/v1/act/is-have-verified-act-reconciliation`,
            params,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
        )
        return response.data;
    } catch (error) {
        console.error("Error fetching success status:", error);
        throw error;
    }
}

export async function acceptInvoiceReconciliation(token: string, data: InvoiceReconciliation): Promise<InvoiceReconciliation> {
    try {
        const response = await apiClient.post<InvoiceReconciliation>(
            `${BASE_URL}/api/v1/invoice/accept`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
        )
        return response.data;
    } catch (error) {
        console.error("Error fetching directory list:", error);
        throw error;
    }
}

export async function generateReport(token: string, params: any): Promise<any> {
    try {
        params.filter = removeNullFields(params.filter);

        return await apiClient.post<any>(
            `${BASE_URL}/api/v1/invoice/report/generate`,
            params,
            {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
        )
    } catch (error) {
        console.error("Error fetching directory list:", error);
        throw error;
    }
}

export async function generateInvoiceTemplate(token: string, params: any): Promise<any> {
    try {
        params.filter = removeNullFields(params.filter);

        return await apiClient.post<any>(
            `${BASE_URL}/api/v1/invoice/template/generate`,
            params,
            {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
        )
    } catch (error) {
        console.error("Error fetching directory list:", error);
        throw error;
    }
}